import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root'
})

export class H2ForecastSteamReformerService {

    constructor(protected http: HttpClient) {

    }

    baseurl = environment.apiBaseUrl + 'H2ForecastReport/geth2forecaststeamreformerawards';

    getReportData() {
        return this.http.get<any[]>(this.baseurl);
    }

}